import { Outlet, ScrollRestoration } from "react-router-dom";

//elements
import Footer from "../elements/footer/Footer"
import NavBar from "../elements/navbar/Navbar"

//styles for the 2026 pages (About NAS, Peer Befriending, AGC, Resources, Contact)
import "../pages/Pages.css"


export default function RootLayout() {
  return (
    <div className="rootLayout">
        <header>
            <NavBar />
         </header>
         <main>
            <Outlet />
         <Footer />
         </main>
         <ScrollRestoration />
        </div>
  )
}
